import { apiPost } from "../utils";
import { apiKey } from "../constants";

export function queryFormAPI(data) {
    let newdata = JSON.stringify(data);
    return apiPost(`/api/submitquery?appKey=${apiKey}`, newdata);
}
